var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vasion-page-title software-page-title"},[_vm._v(" Software ")]),_c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"flex-item"},[_c('SalesForceConnector')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }